import React from "react";

const SwiperSlide = ({ image }) => {
  return (
    <div className="embed-responsive embed-responsive-4by3">
      <div className="embed-responsive-item bg-dark">
        <img
          className="h-100 w-100 object-cover swiper-lazy"
          data-src={image}
          alt=""
        />
        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
      </div>
    </div>
  );
};

export default SwiperSlide;
